import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import s from './OverSummary.scss';

class OverSummary extends React.Component {
  constructor(props) {
    super(props);
    this.overRunScored = 0;
  }
  showBatsManStats() {
    const { batsMan } = this.props.data;
    if (batsMan?.striker?.Balls) {
      return `<span>${batsMan?.striker?.name}</span> <strong>${
        batsMan?.striker?.Runs
      } (${batsMan?.striker?.Balls})</strong>`;
    }
    return `<span>${batsMan?.striker?.name}</span> <strong>${
      batsMan?.striker?.Runs
    } (${batsMan?.striker?.Balls})</strong>`;
  }
  showNonStrikerStats() {
    const { batsMan } = this.props.data;
    if (batsMan?.Nonstriker?.Balls) {
      return `<span>${batsMan?.Nonstriker?.name}</span> <strong>${
        batsMan?.Nonstriker?.Runs
      } (${batsMan?.Nonstriker?.Balls})</strong>`;
    }
    return `<span>${batsMan?.Nonstriker?.name}</span> <strong>${
      batsMan?.Nonstriker?.Runs
    } (${batsMan?.Nonstriker?.Balls})</strong>`;
  }
  showOverRuns() {
    const { runsScored } = this.props.data;
    let overRunScored = 0;
    if (runsScored && typeof runsScored === 'string') {
      let runsScoredArr = runsScored.split(',');
      let runsScoredStr = '';
      runsScoredArr = runsScoredArr.map((item, index) => {
        if (item !== '') {
          overRunScored += parseInt(item);
        }
        if (
          item &&
          (item.includes('w') || item.includes('W')) &&
          (item.includes('(') || item.includes(')'))
        ) {
          runsScoredStr = `${runsScoredStr}<span class="wicketBall capsuleBall">${item}</span>`;
        } else if (
          item &&
          !(item.includes('w') || item.includes('W')) &&
          (item.includes('(') || item.includes(')'))
        ) {
          runsScoredStr = `${runsScoredStr}<span class="normalBall capsuleBall">${item}</span>`;
        } else if (item && (item.includes('w') || item.includes('W'))) {
          runsScoredStr = `${runsScoredStr}<span class="wicketBall">${item}</span>`;
        } else if (item != '') {
          runsScoredStr = `${runsScoredStr}<span class="normalBall">${item}</span>`;
        }
      });
      this.overRunScored = overRunScored;
      return runsScoredStr;
    }
    return '';
  }
  render() {
    const { bowler } = this.props.data;
    const { over, runs, wickets, specialClass } = this.props;
    const wrapperClassName = classnames({
      [`${s.oversummaryWrapper}`]: true,
      [`${specialClass}`]: specialClass !== '',
    });
    return (
      <div className={wrapperClassName}>
        <div className={s.topArea}>
          <div className={s.scoreArea}>
            <div>
              Score after {over ? parseInt(over, 10) + 1 : ''}{' '}
              {over && parseInt(over, 10) === 1 ? 'over' : 'overs'}{' '}
              <strong>
                {runs} - {wickets}
              </strong>
            </div>
          </div>
          <div className={s.runBalls}>
            <div>
              <div className={s.run}>
                Runs Scored: <strong>{this.overRunScored}</strong>{' '}
              </div>
              <div className={s.balls}>
                <div
                  dangerouslySetInnerHTML={{ __html: this.showOverRuns() }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={s.bottomArea}>
          <div className={s.players}>
            <ul>
              <li
                dangerouslySetInnerHTML={{ __html: this.showBatsManStats() }}
              />
              <li
                dangerouslySetInnerHTML={{ __html: this.showNonStrikerStats() }}
              />
            </ul>
          </div>
          <div className={s.bowler}>
            <div>
              <span>{bowler?.name}</span>
              <strong>
                {bowler?.Overs}-{bowler?.Maidens}-{bowler?.Runs}-{
                  bowler?.Wickets
                }
              </strong>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OverSummary.propTypes = {
  data: PropTypes.shape({
    timestamp: PropTypes.number,
    wicket: PropTypes.number,
    scored: PropTypes.number,
    totalRuns: PropTypes.string,
    totalWickets: PropTypes.string,
    runs: PropTypes.string,
    description: PropTypes.string,
    smalldesc: PropTypes.string,
  }).isRequired,
  battingTeam: PropTypes.string.isRequired,
  specialClass: PropTypes.string,
};

export default OverSummary;
